function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { IconWrapper } from '../IconWrapper';
export var EyeIcon = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.54999C15.79 6.54999 19.17 8.67999 20.82 12.05C19.17 15.42 15.79 17.55 12 17.55C8.21 17.55 4.83 15.42 3.18 12.05C4.83 8.67999 8.21 6.54999 12 6.54999ZM12 4.54999C7 4.54999 2.73 7.65999 1 12.05C2.73 16.44 7 19.55 12 19.55C17 19.55 21.27 16.44 23 12.05C21.27 7.65999 17 4.54999 12 4.54999ZM12 9.54999C13.38 9.54999 14.5 10.67 14.5 12.05C14.5 13.43 13.38 14.55 12 14.55C10.62 14.55 9.5 13.43 9.5 12.05C9.5 10.67 10.62 9.54999 12 9.54999ZM12 7.54999C9.52 7.54999 7.5 9.56999 7.5 12.05C7.5 14.53 9.52 16.55 12 16.55C14.48 16.55 16.5 14.53 16.5 12.05C16.5 9.56999 14.48 7.54999 12 7.54999Z",
    fill: "#222"
  })));
});
//# sourceMappingURL=EyeIcon.js.map